import React from "react";
import { Box, List, Divider } from "@mui/material";
import { FileListItem } from "./FileListItem";
import { EmptyFileState } from "./EmptyFileState";
import { useFileExplorerContext } from "../FileExplorerContext";

export const FileList: React.FC = () => {
  const { files } = useFileExplorerContext();

  if (files.length === 0) {
    return <EmptyFileState />;
  }

  return (
    <Box sx={{ flexGrow: 1, overflow: "auto" }}>
      <List>
        {files.map((file, index) => (
          <div key={file.id}>
            <FileListItem file={file} />
            {index < files.length - 1 && <Divider />}
          </div>
        ))}
      </List>
    </Box>
  );
};
